import { gql } from '@apollo/client';

export const GET_CREDENTIALS_VTEX = gql`
  query GetVtexCredentials($storeId: ID!) {
    getVtexCredentials(storeId: $storeId) {
      __typename
      ... on GetVtexCredentialsSuccess {
        code
        credentials {
          vtexAccountName
          appKey
          appToken
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
